import { PmsRiskResolution } from '../domain/pms-risk-resolution';

export class PmsRiskResolutionUtils {
   static normalizeRiskCode(riskCode: string | null | undefined): string {
      return String(riskCode ?? '')
         .trim()
         .toUpperCase();
   }

   static buildIdentityKey(
      targetRowId: string | null | undefined,
      riskCode: string | null | undefined
   ): string {
      const rowId = String(targetRowId ?? '').trim();
      const normalizedRiskCode = PmsRiskResolutionUtils.normalizeRiskCode(riskCode);

      return `${rowId}::${normalizedRiskCode}`;
   }

   static merge(
      current: readonly PmsRiskResolution[],
      changes: readonly PmsRiskResolution[]
   ): PmsRiskResolution[] {
      const merged = new Map<string, PmsRiskResolution>();

      for (const resolution of current) {
         merged.set(
            PmsRiskResolutionUtils.buildIdentityKey(
               resolution.targetRowId,
               resolution.riskCode
            ),
            resolution
         );
      }

      for (const resolution of changes) {
         merged.set(
            PmsRiskResolutionUtils.buildIdentityKey(
               resolution.targetRowId,
               resolution.riskCode
            ),
            resolution
         );
      }

      return Array.from(merged.values());
   }
}
